import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { Incident } from '../models/Incident';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IncidentDetailsComponent } from '../incident/incident-details/incident-details.component';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';
import { IncidentService } from '../incident/incident.service';

@Component({
  selector: 'app-erreur-correspondance',
  imports: [MainComponent, GenericTableComponent],
  templateUrl: './erreur-correspondance.component.html',
  styleUrl: './erreur-correspondance.component.css',
})
export class ErreurCorrespondanceComponent implements OnInit {
  erreurCorrespondance: Incident = new Incident();

  listErreurCorrespondances: Incident[] = [];

  pageInformations: PageInformations = new PageInformations();

  emitClickRow = 'details';

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'description',
        libelle: 'Description',
        property: 'description',
        researchable: false,
      },
      {
        id: 'type',
        libelle: "Type d'erreur de correspondance",
        property: 'type',
        searchOn: 'typeIncident.libelle',
        researchable: false,
      },

      {
        id: 'statut',
        libelle: "Statut d'incident",
        property: 'statut',
        searchOn: 'statutIncident.libelle',
        researchable: false,
      },
      {
        id: 'dateIncident',
        libelle: "Date d'incident",
        property: 'dateIncident',
        type: 'date',
        researchable: true,
      },

      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  constructor(
    private spinner: NgxSpinnerService,
    private searchService: GenericSearchService,
    private dialog: MatDialog,
    private toast: GenericToastrService,
    private incidentService: IncidentService,
    private toastr: GenericToastrService
  ) {}

  ngOnInit(): void {
    this.loadErreurCorrespondance();
  }

  loadErreurCorrespondance(query?: string): void {
    this.spinner.show();

    if (query == null) {
      query =
        '(statutIncident.codeStatutIncident==EC);(typeIncident.codeTypeIncident==CORRG,typeIncident.codeTypeIncident==CORBIT)';
    } else {
      query +=
        ';(statutIncident.codeStatutIncident==EC);(typeIncident.codeTypeIncident!=CORRG;typeIncident.codeTypeIncident!=CORBIT)';
    }
    this.searchService
      .search(
        'incident',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'idIncident=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listErreurCorrespondances = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  pageEvent(event: PageEvent) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadErreurCorrespondance();
  }

  openDetails(row: any) {
    const dialogRef = this.dialog.open(IncidentDetailsComponent, {
      data: {
        incident: row,
      },
      width: '50%',
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result === true) {
          this.loadErreurCorrespondance()
        }
      },
      (error) => {}
    );
  }

  createAffranchi(row: any) {
    const dialogRef = this.dialog.open(GenericValidateComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        libelle:
          'Voulez-vous vraiment affranchir cette erreur de correspondance ?',
      },
    });

    this.spinner.show();
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.incidentService.createAffranchi(row).subscribe(
          (result) => {
            this.spinner.hide();
            this.toastr.openSnackBarSuccess(
              "L'incident a bien été affranchi !"
            );
            this.loadErreurCorrespondance();
          },
          (error) => {
            this.spinner.hide();

            this.toastr.openSnackBarProblem(error.error.message);
          }
        );
      }
    });
  }
}
